import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { FastClick, block } from "../../../core/react";

var map = require("lodash/map");

export var FilterGroupItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FilterGroupItem, _React$PureComponent);

  function FilterGroupItem(props) {
    var _this;

    _classCallCheck(this, FilterGroupItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterGroupItem).call(this, props));
    _this.removeFilter = _this.removeFilter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterGroupItem, [{
    key: "removeFilter",
    value: function removeFilter() {
      var _this$props = this.props,
          removeFilter = _this$props.removeFilter,
          filter = _this$props.filter;

      if (removeFilter) {
        removeFilter(filter);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bemBlocks = _this$props2.bemBlocks,
          label = _this$props2.label,
          itemKey = _this$props2.itemKey;
      return React.createElement(FastClick, {
        handler: this.removeFilter
      }, React.createElement("div", {
        className: bemBlocks.items("value"),
        "data-key": itemKey
      }, label));
    }
  }]);

  return FilterGroupItem;
}(React.PureComponent);
export var FilterGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilterGroup, _React$Component);

  function FilterGroup(props) {
    var _this2;

    _classCallCheck(this, FilterGroup);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FilterGroup).call(this, props));
    _this2.removeFilters = _this2.removeFilters.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(FilterGroup, [{
    key: "removeFilters",
    value: function removeFilters() {
      var _this$props3 = this.props,
          removeFilters = _this$props3.removeFilters,
          filters = _this$props3.filters;

      if (removeFilters) {
        removeFilters(filters);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          mod = _this$props4.mod,
          className = _this$props4.className,
          title = _this$props4.title,
          filters = _this$props4.filters;
      var bemBlocks = {
        container: block(mod).el,
        items: block("".concat(mod, "-items")).el
      };
      return React.createElement("div", {
        key: title,
        className: bemBlocks.container().mix(className)
      }, React.createElement("div", {
        className: bemBlocks.items()
      }, React.createElement("div", {
        className: bemBlocks.items("title")
      }, title), React.createElement("div", {
        className: bemBlocks.items("list")
      }, map(filters, function (filter) {
        return _this3.renderFilter(filter, bemBlocks);
      }))), this.renderRemove(bemBlocks));
    }
  }, {
    key: "renderFilter",
    value: function renderFilter(filter, bemBlocks) {
      var _this$props5 = this.props,
          translate = _this$props5.translate,
          removeFilter = _this$props5.removeFilter;
      return React.createElement(FilterGroupItem, {
        key: filter.value,
        itemKey: filter.value,
        bemBlocks: bemBlocks,
        filter: filter,
        label: translate(filter.value),
        removeFilter: removeFilter
      });
    }
  }, {
    key: "renderRemove",
    value: function renderRemove(bemBlocks) {
      if (!this.props.removeFilters) return null;
      return React.createElement(FastClick, {
        handler: this.removeFilters
      }, React.createElement("div", {
        className: bemBlocks.container("remove-action"),
        onClick: this.removeFilters
      }, "X"));
    }
  }]);

  return FilterGroup;
}(React.Component);
FilterGroup.defaultProps = {
  mod: "sk-filter-group",
  translate: function translate(str) {
    return str;
  }
};